// Shared types for the /analytics module — mirror the backend responses
// from app/api/v1/analytics.py.

export interface AnalyticsFilters {
    period: string;            // 7d|14d|30d|90d|180d|365d|all
    commodity?: string;
    country?: string;
    status?: string;
    risk?: string;
}

export interface Kpi {
    key: string;
    label: string;
    value: number;
    unit: string;              // ha | % | count | Δ
    good_when: 'up' | 'down';
    delta_pct: number | null;
}

export interface SummaryResponse {
    kpis: Kpi[];
    period: { from: string | null; to: string; preset: string };
}

export interface TimeseriesPoint {
    date: string;
    value: number;
    count: number;
}

export interface TimeseriesResponse {
    metric: string;
    granularity: string;
    points: TimeseriesPoint[];
}

export interface BreakdownGroup {
    key: string;
    count: number;
    area_ha: number;
    area_deforested_ha: number;
    high_risk_count: number;
    compliance_rate: number;
}

export interface BreakdownResponse {
    dimension: string;
    groups: BreakdownGroup[];
}

export interface LeaderboardItem {
    polygon_id: string;
    polygon_name: string;
    producer_name: string | null;
    commodity: string;
    country: string | null;
    area_ha: number;
    deforestation_percentage: number | null;
    area_deforested_ha: number | null;
    ndvi_change: number | null;
    compliance_status: string | null;
    risk_level: string | null;
}

export interface LeaderboardResponse {
    metric: string;
    items: LeaderboardItem[];
}

export interface PolygonRow extends LeaderboardItem {
    region: string | null;
    confidence_level: string | null;
    last_analyzed: string | null;
    centroid_lat?: number | null;
    centroid_lon?: number | null;
}

export interface PolygonsResponse {
    count: number;
    items: PolygonRow[];
}

export const TS_METRICS = [
    { key: 'area_deforested', label: 'Deforestation (ha)', unit: 'ha' },
    { key: 'deforestation_pct', label: 'Deforestation (%)', unit: '%' },
    { key: 'compliance_rate', label: 'Compliance rate', unit: '%' },
    { key: 'ndvi_change', label: 'NDVI change', unit: 'Δ' },
    { key: 'jobs', label: 'Analyses run', unit: 'count' },
] as const;

export const PERIODS = [
    { key: '7d', label: '7d' },
    { key: '30d', label: '30d' },
    { key: '90d', label: '90d' },
    { key: '180d', label: '180d' },
    { key: '365d', label: '1y' },
    { key: 'all', label: 'All' },
] as const;
